import { pinLabelBoxText } from './pinLabelBox';

export function StartSVG({ color }) {
    return `<svg width='41' height='51' viewBox='0 0 41 51' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <mask id='path-1-inside-1_1834_43054' fill='white'><path fill-rule='evenodd' clip-rule='evenodd' d='M40.1818 0H0V29.2545L19.6182 51L40.1818 29.2545V0Z'/>
            </mask>
            <path fill-rule='evenodd' clip-rule='evenodd' d='M40.1818 0H0V29.2545L19.6182 51L40.1818 29.2545V0Z' fill='white'/>
            <path d='M0 0V-2H-2V0H0ZM40.1818 0H42.1818V-2H40.1818V0ZM0 29.2545H-2V30.0234L-1.48498 30.5943L0 29.2545ZM19.6182 51L18.1332 52.3397L19.5836 53.9474L21.0713 52.3742L19.6182 51ZM40.1818 29.2545L41.635 30.6287L42.1818 30.0504V29.2545H40.1818ZM0 2H40.1818V-2H0V2ZM2 29.2545V0H-2V29.2545H2ZM21.1032 49.6603L1.48498 27.9148L-1.48498 30.5943L18.1332 52.3397L21.1032 49.6603ZM38.7287 27.8804L18.165 49.6258L21.0713 52.3742L41.635 30.6287L38.7287 27.8804ZM38.1818 0V29.2545H42.1818V0H38.1818Z' fill='${color}' mask='url(#path-1-inside-1_1834_43054)'/>
            <mask id='mask0_1834_43054' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='13' y='12' width='15' height='17'>
                <path d='M22.4 14L22 12H13V29H15V22H20.6L21 24H28V14H22.4Z' fill='white'/>
            </mask>
            <g mask='url(#mask0_1834_43054)'>
                <rect x='8' y='8' width='24.24' height='24.24' fill='#59B863'/>
            </g>
        </svg>
    `;
}

export function EndSVG({ color }) {
    return `<svg width='41' height='51' viewBox='0 0 41 51' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <mask id='path-1-inside-1_1834_43055' fill='white'>
            <path fill-rule='evenodd' clip-rule='evenodd' d='M40.1818 0H0V29.2545L19.6182 51L40.1818 29.2545V0Z'/>
        </mask>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M40.1818 0H0V29.2545L19.6182 51L40.1818 29.2545V0Z' fill='white'/>
        <path d='M0 0V-2H-2V0H0ZM40.1818 0H42.1818V-2H40.1818V0ZM0 29.2545H-2V30.0234L-1.48498 30.5943L0 29.2545ZM19.6182 51L18.1332 52.3397L19.5836 53.9474L21.0713 52.3742L19.6182 51ZM40.1818 29.2545L41.635 30.6287L42.1818 30.0504V29.2545H40.1818ZM0 2H40.1818V-2H0V2ZM2 29.2545V0H-2V29.2545H2ZM21.1032 49.6603L1.48498 27.9148L-1.48498 30.5943L18.1332 52.3397L21.1032 49.6603ZM38.7287 27.8804L18.165 49.6258L21.0713 52.3742L41.635 30.6287L38.7287 27.8804ZM38.1818 0V29.2545H42.1818V0H38.1818Z' fill='${color}' mask='url(#path-1-inside-1_1834_43055)'/>
        <mask id='mask0_1834_43055' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='13' y='12' width='15' height='17'>
            <path d='M22.4 14L22 12H13V29H15V22H20.6L21 24H28V14H22.4Z' fill='white'/>
        </mask>
        <g mask='url(#mask0_1834_43055)'>
            <rect x='8' y='8' width='24.24' height='24.24' fill='#D23E3E'/>
        </g>
    </svg>
    `;
}

export function NetworkEndSVG({ color }) {
    return `<svg width='27' height='33' viewBox='0 0 41 51' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <mask id='path-1-inside-1_1834_43055' fill='white'>
            <path fill-rule='evenodd' clip-rule='evenodd' d='M40.1818 0H0V29.2545L19.6182 51L40.1818 29.2545V0Z'/>
        </mask>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M40.1818 0H0V29.2545L19.6182 51L40.1818 29.2545V0Z' fill='white'/>
        <path d='M0 0V-2H-2V0H0ZM40.1818 0H42.1818V-2H40.1818V0ZM0 29.2545H-2V30.0234L-1.48498 30.5943L0 29.2545ZM19.6182 51L18.1332 52.3397L19.5836 53.9474L21.0713 52.3742L19.6182 51ZM40.1818 29.2545L41.635 30.6287L42.1818 30.0504V29.2545H40.1818ZM0 2H40.1818V-2H0V2ZM2 29.2545V0H-2V29.2545H2ZM21.1032 49.6603L1.48498 27.9148L-1.48498 30.5943L18.1332 52.3397L21.1032 49.6603ZM38.7287 27.8804L18.165 49.6258L21.0713 52.3742L41.635 30.6287L38.7287 27.8804ZM38.1818 0V29.2545H42.1818V0H38.1818Z' fill='${color}' mask='url(#path-1-inside-1_1834_43055)'/><mask id='mask0_1834_43055' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='13' y='12' width='15' height='17'><path d='M22.4 14L22 12H13V29H15V22H20.6L21 24H28V14H22.4Z' fill='white'/>
        </mask>
        <g mask='url(#mask0_1834_43055)'>
            <rect x='8' y='8' width='24.24' height='24.24' fill='navy'/>
        </g>
    </svg>
    `;
}

export function DefaultSVG({ color }) {
    return `<svg width='27' height='33' viewBox='0 0 27 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <mask id='path-1-inside-1_1834_43062' fill='white'>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z'/></mask><path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z' fill='${color}'/>
        <path d='M0 0V-2H-2V0H0ZM26.0014 0H28.0014V-2H26.0014V0ZM0 18.9304H-2V20.9304H0V18.9304ZM0.00385723 18.9304L1.48884 17.5907L0.893144 16.9304H0.00385723V18.9304ZM12.6967 32.9996L11.2117 34.3394L12.6622 35.947L14.1499 34.3738L12.6967 32.9996ZM26.0013 18.9304V16.9304H25.14L24.5481 17.5563L26.0013 18.9304ZM26.0014 18.9304V20.9304H28.0014V18.9304H26.0014ZM26.0014 18.9303L24.5481 17.5563L24.0014 18.1346V18.9303H26.0014ZM26.0033 18.9283L27.4567 20.3023L30.6464 16.9283H26.0033V18.9283ZM26.0014 18.9283H24.0014V20.9283H26.0014V18.9283ZM0 2H26.0014V-2H0V2ZM2 18.9304V0H-2V18.9304H2ZM0.00385723 16.9304H0V20.9304H0.00385723V16.9304ZM14.1817 31.6599L1.48884 17.5907L-1.48112 20.2702L11.2117 34.3394L14.1817 31.6599ZM24.5481 17.5563L11.2436 31.6255L14.1499 34.3738L27.4544 20.3046L24.5481 17.5563ZM26.0014 16.9304H26.0013V20.9304H26.0014V16.9304ZM24.0014 18.9303V18.9304H28.0014V18.9303H24.0014ZM24.55 17.5543L24.5481 17.5563L27.4548 20.3043L27.4567 20.3023L24.55 17.5543ZM26.0014 20.9283H26.0033V16.9283H26.0014V20.9283ZM24.0014 0V18.9283H28.0014V0H24.0014Z' fill='white' mask='url(#path-1-inside-1_1834_43062)'/>
    </svg>`;
}

export function DefaultSVGSelected({ color, altColor }) {
    return `<svg width='27' height='33' viewBox='0 0 27 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <mask id='path-1-inside-1_1834_43062' fill='white'>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z'/></mask><path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z' fill='${color}'/>
        <path d='M0 0V-2H-2V0H0ZM26.0014 0H28.0014V-2H26.0014V0ZM0 18.9304H-2V20.9304H0V18.9304ZM0.00385723 18.9304L1.48884 17.5907L0.893144 16.9304H0.00385723V18.9304ZM12.6967 32.9996L11.2117 34.3394L12.6622 35.947L14.1499 34.3738L12.6967 32.9996ZM26.0013 18.9304V16.9304H25.14L24.5481 17.5563L26.0013 18.9304ZM26.0014 18.9304V20.9304H28.0014V18.9304H26.0014ZM26.0014 18.9303L24.5481 17.5563L24.0014 18.1346V18.9303H26.0014ZM26.0033 18.9283L27.4567 20.3023L30.6464 16.9283H26.0033V18.9283ZM26.0014 18.9283H24.0014V20.9283H26.0014V18.9283ZM0 2H26.0014V-2H0V2ZM2 18.9304V0H-2V18.9304H2ZM0.00385723 16.9304H0V20.9304H0.00385723V16.9304ZM14.1817 31.6599L1.48884 17.5907L-1.48112 20.2702L11.2117 34.3394L14.1817 31.6599ZM24.5481 17.5563L11.2436 31.6255L14.1499 34.3738L27.4544 20.3046L24.5481 17.5563ZM26.0014 16.9304H26.0013V20.9304H26.0014V16.9304ZM24.0014 18.9303V18.9304H28.0014V18.9303H24.0014ZM24.55 17.5543L24.5481 17.5563L27.4548 20.3043L27.4567 20.3023L24.55 17.5543ZM26.0014 20.9283H26.0033V16.9283H26.0014V20.9283ZM24.0014 0V18.9283H28.0014V0H24.0014Z' fill='white' mask='url(#path-1-inside-1_1834_43062)'/>
    </svg>`;
}

export function AltDropoffSVG1({ color, altColor }) {
    return `<svg width='27' height='33' viewBox='0 0 27 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <defs>
            <pattern id="diagonalHatch" width="5" height="5" patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse">
                <line x1="0" y1="0" x2="0" y2="5" style="stroke:white; stroke-width:5" />
            </pattern>
        </defs>
        <mask id='path-1-inside-1_1834_43065' fill="url(#diagonalHatch)">
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z'/>
        </mask>
        <mask id='path-1-inside-1_1834_43065-b' fill="white">
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z'/>
        </mask>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z' fill='${color}'/>
        <path fill='white' d='M0 0V-2H-2V0H0ZM26.0014 0H28.0014V-2H26.0014V0ZM0 18.9304H-2V20.9304H0V18.9304ZM0.00385723 18.9304L1.48884 17.5907L0.893144 16.9304H0.00385723V18.9304ZM12.6967 32.9996L11.2117 34.3394L12.6622 35.947L14.1499 34.3738L12.6967 32.9996ZM26.0013 18.9304V16.9304H25.14L24.5481 17.5563L26.0013 18.9304ZM26.0014 18.9304V20.9304H28.0014V18.9304H26.0014ZM26.0014 18.9303L24.5481 17.5563L24.0014 18.1346V18.9303H26.0014ZM26.0033 18.9283L27.4567 20.3023L30.6464 16.9283H26.0033V18.9283ZM26.0014 18.9283H24.0014V20.9283H26.0014V18.9283ZM0 2H26.0014V-2H0V2ZM2 18.9304V0H-2V18.9304H2ZM0.00385723 16.9304H0V20.9304H0.00385723V16.9304ZM14.1817 31.6599L1.48884 17.5907L-1.48112 20.2702L11.2117 34.3394L14.1817 31.6599ZM24.5481 17.5563L11.2436 31.6255L14.1499 34.3738L27.4544 20.3046L24.5481 17.5563ZM26.0014 16.9304H26.0013V20.9304H26.0014V16.9304ZM24.0014 18.9303V18.9304H28.0014V18.9303H24.0014ZM24.55 17.5543L24.5481 17.5563L27.4548 20.3043L27.4567 20.3023L24.55 17.5543ZM26.0014 20.9283H26.0033V16.9283H26.0014V20.9283ZM24.0014 0V18.9283H28.0014V0H24.0014Z' mask='url(#path-1-inside-1_1834_43065-b)'/>
        <path fill='${altColor}' d='M0 0V-2H-2V0H0ZM26.0014 0H28.0014V-2H26.0014V0ZM0 18.9304H-2V20.9304H0V18.9304ZM0.00385723 18.9304L1.48884 17.5907L0.893144 16.9304H0.00385723V18.9304ZM12.6967 32.9996L11.2117 34.3394L12.6622 35.947L14.1499 34.3738L12.6967 32.9996ZM26.0013 18.9304V16.9304H25.14L24.5481 17.5563L26.0013 18.9304ZM26.0014 18.9304V20.9304H28.0014V18.9304H26.0014ZM26.0014 18.9303L24.5481 17.5563L24.0014 18.1346V18.9303H26.0014ZM26.0033 18.9283L27.4567 20.3023L30.6464 16.9283H26.0033V18.9283ZM26.0014 18.9283H24.0014V20.9283H26.0014V18.9283ZM0 2H26.0014V-2H0V2ZM2 18.9304V0H-2V18.9304H2ZM0.00385723 16.9304H0V20.9304H0.00385723V16.9304ZM14.1817 31.6599L1.48884 17.5907L-1.48112 20.2702L11.2117 34.3394L14.1817 31.6599ZM24.5481 17.5563L11.2436 31.6255L14.1499 34.3738L27.4544 20.3046L24.5481 17.5563ZM26.0014 16.9304H26.0013V20.9304H26.0014V16.9304ZM24.0014 18.9303V18.9304H28.0014V18.9303H24.0014ZM24.55 17.5543L24.5481 17.5563L27.4548 20.3043L27.4567 20.3023L24.55 17.5543ZM26.0014 20.9283H26.0033V16.9283H26.0014V20.9283ZM24.0014 0V18.9283H28.0014V0H24.0014Z' mask='url(#path-1-inside-1_1834_43065)'/>
    </svg>`;
}
export function AltDropoffSVG2({ color, altColor }) {
    return `<svg width='27' height='33' viewBox='0 0 27 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <defs>
            <pattern id="checkers" x="0" y="0" width="6" height="6" patternUnits="userSpaceOnUse">
                <rect fill="white" x="0" width="3" height="3" y="0"></rect>
                <rect fill="white" x="3" width="3" height="3" y="3"></rect>
            </pattern>
        </defs>
        <mask id='path-1-inside-1_1834_43063' fill="url(#checkers)">
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z'/></mask>
        <mask id='path-1-inside-1_1834_43063-b' fill="white">
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z'/></mask>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z' fill='${color}'/>
        <path fill='white' d='M0 0V-2H-2V0H0ZM26.0014 0H28.0014V-2H26.0014V0ZM0 18.9304H-2V20.9304H0V18.9304ZM0.00385723 18.9304L1.48884 17.5907L0.893144 16.9304H0.00385723V18.9304ZM12.6967 32.9996L11.2117 34.3394L12.6622 35.947L14.1499 34.3738L12.6967 32.9996ZM26.0013 18.9304V16.9304H25.14L24.5481 17.5563L26.0013 18.9304ZM26.0014 18.9304V20.9304H28.0014V18.9304H26.0014ZM26.0014 18.9303L24.5481 17.5563L24.0014 18.1346V18.9303H26.0014ZM26.0033 18.9283L27.4567 20.3023L30.6464 16.9283H26.0033V18.9283ZM26.0014 18.9283H24.0014V20.9283H26.0014V18.9283ZM0 2H26.0014V-2H0V2ZM2 18.9304V0H-2V18.9304H2ZM0.00385723 16.9304H0V20.9304H0.00385723V16.9304ZM14.1817 31.6599L1.48884 17.5907L-1.48112 20.2702L11.2117 34.3394L14.1817 31.6599ZM24.5481 17.5563L11.2436 31.6255L14.1499 34.3738L27.4544 20.3046L24.5481 17.5563ZM26.0014 16.9304H26.0013V20.9304H26.0014V16.9304ZM24.0014 18.9303V18.9304H28.0014V18.9303H24.0014ZM24.55 17.5543L24.5481 17.5563L27.4548 20.3043L27.4567 20.3023L24.55 17.5543ZM26.0014 20.9283H26.0033V16.9283H26.0014V20.9283ZM24.0014 0V18.9283H28.0014V0H24.0014Z' mask='url(#path-1-inside-1_1834_43063-b)'/>
        <path fill='${altColor}' d='M0 0V-2H-2V0H0ZM26.0014 0H28.0014V-2H26.0014V0ZM0 18.9304H-2V20.9304H0V18.9304ZM0.00385723 18.9304L1.48884 17.5907L0.893144 16.9304H0.00385723V18.9304ZM12.6967 32.9996L11.2117 34.3394L12.6622 35.947L14.1499 34.3738L12.6967 32.9996ZM26.0013 18.9304V16.9304H25.14L24.5481 17.5563L26.0013 18.9304ZM26.0014 18.9304V20.9304H28.0014V18.9304H26.0014ZM26.0014 18.9303L24.5481 17.5563L24.0014 18.1346V18.9303H26.0014ZM26.0033 18.9283L27.4567 20.3023L30.6464 16.9283H26.0033V18.9283ZM26.0014 18.9283H24.0014V20.9283H26.0014V18.9283ZM0 2H26.0014V-2H0V2ZM2 18.9304V0H-2V18.9304H2ZM0.00385723 16.9304H0V20.9304H0.00385723V16.9304ZM14.1817 31.6599L1.48884 17.5907L-1.48112 20.2702L11.2117 34.3394L14.1817 31.6599ZM24.5481 17.5563L11.2436 31.6255L14.1499 34.3738L27.4544 20.3046L24.5481 17.5563ZM26.0014 16.9304H26.0013V20.9304H26.0014V16.9304ZM24.0014 18.9303V18.9304H28.0014V18.9303H24.0014ZM24.55 17.5543L24.5481 17.5563L27.4548 20.3043L27.4567 20.3023L24.55 17.5543ZM26.0014 20.9283H26.0033V16.9283H26.0014V20.9283ZM24.0014 0V18.9283H28.0014V0H24.0014Z' mask='url(#path-1-inside-1_1834_43063)'/>
    </svg>`;
}
export function AltDropoffSVG3({ color, altColor }) {
    return `<svg width='27' height='33' viewBox='0 0 27 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <defs>
            <pattern id="dashed" width="14" height="14" x="0" patternTransform="rotate(90 0 0)" patternUnits="userSpaceOnUse">
                <line x1="0" y1="0" x2="0" y2="14" style="stroke:white; stroke-width:18" />
            </pattern>
        </defs>
        <mask id='path-1-inside-1_1834_43064' fill="url(#dashed)">
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z'/></mask>
        <mask id='path-1-inside-1_1834_43064-b' fill="white">
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z'/></mask>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z' fill='${color}'/>
        <path fill='white' d='M0 0V-2H-2V0H0ZM26.0014 0H28.0014V-2H26.0014V0ZM0 18.9304H-2V20.9304H0V18.9304ZM0.00385723 18.9304L1.48884 17.5907L0.893144 16.9304H0.00385723V18.9304ZM12.6967 32.9996L11.2117 34.3394L12.6622 35.947L14.1499 34.3738L12.6967 32.9996ZM26.0013 18.9304V16.9304H25.14L24.5481 17.5563L26.0013 18.9304ZM26.0014 18.9304V20.9304H28.0014V18.9304H26.0014ZM26.0014 18.9303L24.5481 17.5563L24.0014 18.1346V18.9303H26.0014ZM26.0033 18.9283L27.4567 20.3023L30.6464 16.9283H26.0033V18.9283ZM26.0014 18.9283H24.0014V20.9283H26.0014V18.9283ZM0 2H26.0014V-2H0V2ZM2 18.9304V0H-2V18.9304H2ZM0.00385723 16.9304H0V20.9304H0.00385723V16.9304ZM14.1817 31.6599L1.48884 17.5907L-1.48112 20.2702L11.2117 34.3394L14.1817 31.6599ZM24.5481 17.5563L11.2436 31.6255L14.1499 34.3738L27.4544 20.3046L24.5481 17.5563ZM26.0014 16.9304H26.0013V20.9304H26.0014V16.9304ZM24.0014 18.9303V18.9304H28.0014V18.9303H24.0014ZM24.55 17.5543L24.5481 17.5563L27.4548 20.3043L27.4567 20.3023L24.55 17.5543ZM26.0014 20.9283H26.0033V16.9283H26.0014V20.9283ZM24.0014 0V18.9283H28.0014V0H24.0014Z' mask='url(#path-1-inside-1_1834_43064-b)'/>
        <path fill='${altColor}' d='M0 0V-2H-2V0H0ZM26.0014 0H28.0014V-2H26.0014V0ZM0 18.9304H-2V20.9304H0V18.9304ZM0.00385723 18.9304L1.48884 17.5907L0.893144 16.9304H0.00385723V18.9304ZM12.6967 32.9996L11.2117 34.3394L12.6622 35.947L14.1499 34.3738L12.6967 32.9996ZM26.0013 18.9304V16.9304H25.14L24.5481 17.5563L26.0013 18.9304ZM26.0014 18.9304V20.9304H28.0014V18.9304H26.0014ZM26.0014 18.9303L24.5481 17.5563L24.0014 18.1346V18.9303H26.0014ZM26.0033 18.9283L27.4567 20.3023L30.6464 16.9283H26.0033V18.9283ZM26.0014 18.9283H24.0014V20.9283H26.0014V18.9283ZM0 2H26.0014V-2H0V2ZM2 18.9304V0H-2V18.9304H2ZM0.00385723 16.9304H0V20.9304H0.00385723V16.9304ZM14.1817 31.6599L1.48884 17.5907L-1.48112 20.2702L11.2117 34.3394L14.1817 31.6599ZM24.5481 17.5563L11.2436 31.6255L14.1499 34.3738L27.4544 20.3046L24.5481 17.5563ZM26.0014 16.9304H26.0013V20.9304H26.0014V16.9304ZM24.0014 18.9303V18.9304H28.0014V18.9303H24.0014ZM24.55 17.5543L24.5481 17.5563L27.4548 20.3043L27.4567 20.3023L24.55 17.5543ZM26.0014 20.9283H26.0033V16.9283H26.0014V20.9283ZM24.0014 0V18.9283H28.0014V0H24.0014Z' mask='url(#path-1-inside-1_1834_43064)'/>
    </svg>`;
}

export function SquareSVG({ color }) {
    return `<svg width='34' height='35' viewBox='0 0 34 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect x='1.39258' y='1.39648' width='30.6958' height='32.5205' fill='${color}' stroke='white' stroke-width='2'/>
    </svg>`;
}

export function CircleSVG({ color }) {
    return `<svg width='34' height='36' viewBox='0 0 34 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M32.0884 18.0962C32.0884 27.1283 25.1664 34.3564 16.7405 34.3564C8.31454 34.3564 1.39258 27.1283 1.39258 18.0962C1.39258 9.06403 8.31454 1.83594 16.7405 1.83594C25.1664 1.83594 32.0884 9.06403 32.0884 18.0962Z' fill='${color}' stroke='white' stroke-width='2'/>
    </svg>`;
}
export function TriangleSVG({ color }) {
    return `<svg width='39' height='36' viewBox='0 0 39 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M2.21369 34.9455L19.7411 2.89287L37.2685 34.9455H2.21369Z' fill='${color}' stroke='white' stroke-width='2'/>
    </svg>`;
}
export function PentagonSVG({ color }) {
    return `<svg width='37' height='36' viewBox='0 0 37 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M1.76395 14.5303L18.7393 2.19701L35.7146 14.5303L29.2306 34.486H8.24794L1.76395 14.5303Z' fill='${color}' stroke='white' stroke-width='2'/>
    </svg>`;
}
export function StarSVG({ color }) {
    return `<svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_5790_130124" fill="white">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M31.9951 12.6233L35.899 4.50643L27.7821 8.41035L19.989 0.617245L12.1091 8.49716L4.92018 5.3474L8.06993 12.5363L0.190018 20.4162L7.98312 28.2093L4.0792 36.3262L12.1961 32.4223L19.989 40.2152L27.8688 32.3354L35.058 35.4853L31.9082 28.2961L39.788 20.4162L31.9951 12.6233Z"/>
    </mask>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M31.9951 12.6233L35.899 4.50643L27.7821 8.41035L19.989 0.617245L12.1091 8.49716L4.92018 5.3474L8.06993 12.5363L0.190018 20.4162L7.98312 28.2093L4.0792 36.3262L12.1961 32.4223L19.989 40.2152L27.8688 32.3354L35.058 35.4853L31.9082 28.2961L39.788 20.4162L31.9951 12.6233Z" fill='${color}'/>
    <path d="M35.899 4.50643L37.7014 5.3733L40.1748 0.230638L35.0321 2.70406L35.899 4.50643ZM31.9951 12.6233L30.1927 11.7565L29.578 13.0346L30.5809 14.0375L31.9951 12.6233ZM27.7821 8.41035L26.3679 9.82456L27.3708 10.8275L28.649 10.2127L27.7821 8.41035ZM19.989 0.617245L21.4032 -0.796969L19.989 -2.21118L18.5748 -0.796969L19.989 0.617245ZM12.1091 8.49716L11.3065 10.329L12.5575 10.8772L13.5233 9.91137L12.1091 8.49716ZM4.92018 5.3474L5.7228 3.51552L1.03389 1.46112L3.08829 6.15003L4.92018 5.3474ZM8.06993 12.5363L9.48415 13.9505L10.4499 12.9847L9.90182 11.7337L8.06993 12.5363ZM0.190018 20.4162L-1.2242 19.002L-2.63841 20.4162L-1.2242 21.8304L0.190018 20.4162ZM7.98312 28.2093L9.78549 29.0762L10.4002 27.798L9.39733 26.7951L7.98312 28.2093ZM4.0792 36.3262L2.27683 35.4594L-0.196588 40.602L4.94607 38.1286L4.0792 36.3262ZM12.1961 32.4223L13.6103 31.0081L12.6074 30.0052L11.3292 30.6199L12.1961 32.4223ZM19.989 40.2152L18.5748 41.6294L19.989 43.0437L21.4032 41.6294L19.989 40.2152ZM27.8688 32.3354L28.6715 30.5035L27.4204 29.9554L26.4546 30.9212L27.8688 32.3354ZM35.058 35.4853L34.2554 37.3171L38.9443 39.3716L36.8899 34.6826L35.058 35.4853ZM31.9082 28.2961L30.4939 26.8819L29.5281 27.8477L30.0763 29.0987L31.9082 28.2961ZM39.788 20.4162L41.2022 21.8304L42.6164 20.4162L41.2022 19.002L39.788 20.4162ZM34.0966 3.63956L30.1927 11.7565L33.7975 13.4902L37.7014 5.3733L34.0966 3.63956ZM28.649 10.2127L36.7659 6.3088L35.0321 2.70406L26.9152 6.60798L28.649 10.2127ZM18.5748 2.03146L26.3679 9.82456L29.1963 6.99613L21.4032 -0.796969L18.5748 2.03146ZM13.5233 9.91137L21.4032 2.03146L18.5748 -0.796969L10.6949 7.08295L13.5233 9.91137ZM4.11755 7.17929L11.3065 10.329L12.9117 6.66528L5.7228 3.51552L4.11755 7.17929ZM9.90182 11.7337L6.75206 4.54478L3.08829 6.15003L6.23805 13.3389L9.90182 11.7337ZM1.60423 21.8304L9.48415 13.9505L6.65572 11.1221L-1.2242 19.002L1.60423 21.8304ZM9.39733 26.7951L1.60423 19.002L-1.2242 21.8304L6.56891 29.6235L9.39733 26.7951ZM5.88157 37.1931L9.78549 29.0762L6.18075 27.3425L2.27683 35.4594L5.88157 37.1931ZM11.3292 30.6199L3.21233 34.5239L4.94607 38.1286L13.063 34.2247L11.3292 30.6199ZM21.4032 38.801L13.6103 31.0081L10.7819 33.8365L18.5748 41.6294L21.4032 38.801ZM26.4546 30.9212L18.5748 38.801L21.4032 41.6294L29.2831 33.7496L26.4546 30.9212ZM35.8607 33.6534L28.6715 30.5035L27.0662 34.1673L34.2554 37.3171L35.8607 33.6534ZM30.0763 29.0987L33.2262 36.2879L36.8899 34.6826L33.74 27.4935L30.0763 29.0987ZM38.3738 19.002L30.4939 26.8819L33.3224 29.7103L41.2022 21.8304L38.3738 19.002ZM30.5809 14.0375L38.3738 21.8304L41.2022 19.002L33.4093 11.2091L30.5809 14.0375Z" fill="white" mask="url(#path-1-inside-1_5790_130124)"/>
    </svg>`;
}

export function CrossSVG({ color }) {
    return `<svg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <mask id='path-1-inside-1_5790_130152' fill='white'>
                <path fill-rule='evenodd' clip-rule='evenodd' d='M26.7383 0.697266H9.73828V9.69726L0.738281 9.69726V26.6973H9.73828V35.6973H26.7383V26.6973H35.7383V9.69727L26.7383 9.69726V0.697266Z'/>
            </mask>
            <path fill-rule='evenodd' clip-rule='evenodd' d='M26.7383 0.697266H9.73828V9.69726L0.738281 9.69726V26.6973H9.73828V35.6973H26.7383V26.6973H35.7383V9.69727L26.7383 9.69726V0.697266Z' fill='${color}'/><path d='M9.73828 0.697266V-1.30273H7.73828V0.697266H9.73828ZM26.7383 0.697266H28.7383V-1.30273H26.7383V0.697266ZM9.73828 9.69726V11.6973H11.7383V9.69726H9.73828ZM0.738281 9.69726L0.738281 7.69726H-1.26172V9.69726H0.738281ZM0.738281 26.6973H-1.26172V28.6973H0.738281V26.6973ZM9.73828 26.6973H11.7383V24.6973H9.73828V26.6973ZM9.73828 35.6973H7.73828V37.6973H9.73828V35.6973ZM26.7383 35.6973V37.6973H28.7383V35.6973H26.7383ZM26.7383 26.6973V24.6973H24.7383V26.6973H26.7383ZM35.7383 26.6973V28.6973H37.7383V26.6973H35.7383ZM35.7383 9.69727H37.7383V7.69727H35.7383V9.69727ZM26.7383 9.69726H24.7383V11.6973H26.7383V9.69726ZM9.73828 2.69727H26.7383V-1.30273H9.73828V2.69727ZM11.7383 9.69726V0.697266H7.73828V9.69726H11.7383ZM0.738281 11.6973L9.73828 11.6973V7.69726L0.738281 7.69726L0.738281 11.6973ZM2.73828 26.6973V9.69726H-1.26172V26.6973H2.73828ZM9.73828 24.6973H0.738281V28.6973H9.73828V24.6973ZM11.7383 35.6973V26.6973H7.73828V35.6973H11.7383ZM26.7383 33.6973H9.73828V37.6973H26.7383V33.6973ZM24.7383 26.6973V35.6973H28.7383V26.6973H24.7383ZM35.7383 24.6973H26.7383V28.6973H35.7383V24.6973ZM33.7383 9.69727V26.6973H37.7383V9.69727H33.7383ZM26.7383 11.6973L35.7383 11.6973V7.69727L26.7383 7.69726V11.6973ZM24.7383 0.697266V9.69726H28.7383V0.697266H24.7383Z' fill='white' mask='url(#path-1-inside-1_5790_130152)'/>
        </svg>`;
}

export function RectangleSVG({ color }) {
    return `<svg width='26' height='36' viewBox='0 0 26 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <rect x='1.4707' y='1.72461' width='23' height='32.5205' fill='${color}' stroke='white' stroke-width='2'/>
        </svg>`;
}

export function DiamondSVG({ color }) {
    return `<svg width='32' height='40' viewBox='0 0 24 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M1.62324 17L11.7547 1.80278L21.8862 17L11.7547 32.1972L1.62324 17Z' fill='${color}' stroke='white' stroke-width='2'/>
        </svg>`;
}

export function HeartSVG({ color }) {
    return `<svg xmlns='http://www.w3.org/2000/svg' width='34' height='36' viewBox='0 0 24 24' fill='none' stroke='#000000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'>
            <path d='M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z' fill='${color}' stroke='white' stroke-width='2'>
            </path>
        </svg>`;
}

export function Abstract1SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_67603)">
    <mask id="mask0_9080_67603" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="200">
    <path d="M200.5 0H0.5V200H200.5V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_9080_67603)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M50.5 0H0.5V100C0.5 155.228 45.2715 200 100.5 200C155.728 200 200.5 155.228 200.5 100V0H150.5C122.886 0 100.5 22.3858 100.5 50C100.5 22.3858 78.1142 0 50.5 0Z" fill='${color}'/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_9080_67603">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>`;
}

export function Abstract2SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_68243)">
    <mask id="mask0_9080_68243" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="200">
    <path d="M200.5 0H0.5V200H200.5V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_9080_68243)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9046 100.422C8.81777 102.425 1.21426 111.325 1.21426 122L1.21426 178C1.21426 190.15 11.064 200 23.2143 200H79.2143C90.1402 200 99.2058 192.035 100.922 181.595C102.925 191.682 111.825 199.286 122.5 199.286H178.5C190.65 199.286 200.5 189.436 200.5 177.286V121.286C200.5 110.36 192.535 101.294 182.096 99.578C192.182 97.5746 199.786 88.6752 199.786 78V22C199.786 9.84974 189.936 2.97894e-06 177.786 2.44784e-06L121.786 0C110.86 -4.77585e-07 101.794 7.96461 100.078 18.4046C98.0747 8.31778 89.1753 0.71428 78.5 0.71428H22.5C10.3497 0.71428 0.5 10.564 0.5 22.7143V78.7143C0.5 89.6401 8.46462 98.7058 18.9046 100.422Z" fill="${color}"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_9080_68243">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>`;
}

export function Abstract3SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_68059)">
    <mask id="mask0_9080_68059" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="200">
    <path d="M200.5 0H0.5V200H200.5V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_9080_68059)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M29.7893 29.2893C19.7658 39.3128 16.1458 53.315 18.9294 66.2123C7.84132 73.3638 0.5 85.8246 0.5 100C0.499998 114.175 7.84132 126.636 18.9294 133.788C16.1458 146.685 19.7658 160.687 29.7893 170.711C39.8129 180.734 53.815 184.354 66.7123 181.571C73.8639 192.659 86.3246 200 100.5 200C114.675 200 127.136 192.659 134.288 181.571C147.185 184.354 161.187 180.734 171.211 170.711C181.234 160.687 184.854 146.685 182.071 133.788C193.159 126.636 200.5 114.175 200.5 100C200.5 85.8246 193.159 73.3638 182.071 66.2123C184.854 53.315 181.234 39.3129 171.211 29.2893C161.187 19.2658 147.185 15.6458 134.288 18.4294C127.136 7.34133 114.675 0 100.5 0C86.3246 0 73.8638 7.34131 66.7123 18.4293C53.815 15.6458 39.8129 19.2658 29.7893 29.2893Z" fill="${color}"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_9080_68059">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>
    `;
}

export function Abstract4SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_67987)">
    <path d="M0.5 47.4235C0.5 38.0237 7.03608 29.9057 16.2703 28.1488C36.9827 24.2081 73.8424 18 100.5 18C127.158 18 164.017 24.2081 184.73 28.1488C193.964 29.9057 200.5 38.0237 200.5 47.4235V150.374C200.5 159.424 194.431 167.333 185.62 169.396C165.183 174.181 127.851 181.934 100.5 181.934C73.1487 181.934 35.8172 174.181 15.3798 169.396C6.56883 167.333 0.5 159.424 0.5 150.374V47.4235Z" fill="${color}"/>
    </g>
    <defs>
    <clipPath id="clip0_9080_67987">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>`;
}

export function Abstract5SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_67857)">
    <mask id="mask0_9080_67857" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="200">
    <path d="M200.5 0H0.5V200H200.5V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_9080_67857)">
    <path d="M100.5 173.738C24.8644 236.944 -36.4438 175.636 26.7621 100C-36.4438 24.3644 24.8644 -36.9438 100.5 26.2621C176.121 -36.9438 237.444 24.3644 174.238 100C237.444 175.578 176.121 236.944 100.5 173.738Z" fill="${color}"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_9080_67857">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>`;
}

export function Abstract6SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_67845)">
    <mask id="mask0_9080_67845" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="200">
    <path d="M200.5 0H0.5V200H200.5V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_9080_67845)">
    <path d="M140.497 139.994C220.501 220.002 -19.5011 220.002 60.5033 139.994C-19.5011 220.002 -19.5011 -19.9992 60.5033 59.9975C-19.5011 -19.9992 220.501 -19.9992 140.497 59.9975C220.501 -19.9992 220.501 220.002 140.497 139.994Z" fill="${color}"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_9080_67845">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>
    `;
}

export function Abstract7SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_67819)">
    <mask id="mask0_9080_67819" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="200">
    <path d="M200.5 0H0.5V200H200.5V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_9080_67819)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M120.5 14.2857C120.5 6.39593 114.104 0 106.214 0H94.7857C86.8959 0 80.5 6.39594 80.5 14.2857V17.2269C80.5 29.9541 65.1123 36.3279 56.1128 27.3284L54.033 25.2487C48.4541 19.6698 39.4089 19.6698 33.8299 25.2487L25.7487 33.3299C20.1698 38.9088 20.1698 47.954 25.7487 53.533L27.8285 55.6128C36.828 64.6123 30.4542 80 17.727 80H14.7857C6.89593 80 0.5 86.3959 0.5 94.2857V105.714C0.5 113.604 6.89593 120 14.7857 120H17.7269C30.4542 120 36.828 135.388 27.8285 144.387L25.7487 146.467C20.1698 152.046 20.1698 161.091 25.7487 166.67L33.8299 174.751C39.4089 180.33 48.4541 180.33 54.033 174.751L56.1128 172.671C65.1122 163.672 80.5 170.046 80.5 182.773V185.714C80.5 193.604 86.8959 200 94.7857 200H106.214C114.104 200 120.5 193.604 120.5 185.714V182.773C120.5 170.046 135.888 163.672 144.887 172.671L146.967 174.751C152.546 180.33 161.591 180.33 167.17 174.751L175.251 166.67C180.83 161.091 180.83 152.046 175.251 146.467L173.172 144.387C164.172 135.388 170.546 120 183.273 120H186.214C194.104 120 200.5 113.604 200.5 105.714V94.2857C200.5 86.3959 194.104 80 186.214 80H183.273C170.546 80 164.172 64.6123 173.171 55.6128L175.251 53.5329C180.83 47.954 180.83 38.9088 175.251 33.3299L167.17 25.2487C161.591 19.6697 152.546 19.6697 146.967 25.2487L144.887 27.3284C135.888 36.3279 120.5 29.9541 120.5 17.2269V14.2857Z" fill="${color}"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_9080_67819">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>`;
}

export function Abstract8SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_67813)">
    <mask id="mask0_9080_67813" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="200">
    <path d="M200.5 0H0.5V200H200.5V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_9080_67813)">
    <path d="M100.494 200V184.439C49.5583 184.439 0.5 150.932 0.5 100H16.0495C16.0495 49.0678 49.5583 0 100.494 0V15.5612C151.429 15.5612 200.5 49.0678 200.5 100H184.951C184.951 150.932 151.429 200 100.494 200Z" fill="${color}"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_9080_67813">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>
    `;
}

export function Abstract9SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_67801)">
    <mask id="mask0_9080_67801" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="200">
    <path d="M200.5 0H0.5V200H200.5V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_9080_67801)">
    <path d="M136.053 160.869C166.523 213.044 34.4891 213.044 64.9593 160.869C8.51516 213.044 -12.5437 191.961 39.6312 135.553C-12.5437 166.023 -12.5437 33.9891 39.6312 64.4593C-12.5437 8.01516 8.53907 -13.0437 64.9593 39.1312C34.4891 -13.0437 166.523 -13.0437 136.053 39.1312C192.497 -13.0437 213.544 8.03907 161.369 64.4593C213.544 33.9891 213.544 166.023 161.369 135.553C213.544 191.985 192.497 213.044 136.053 160.869Z" fill="${color}"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_9080_67801">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>
    `;
}

export function Abstract10SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_67765)">
    <mask id="mask0_9080_67765" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="200">
    <path d="M200.5 0H0.5V200H200.5V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_9080_67765)">
    <path d="M165.719 191.946C166.119 196.381 155.032 202.035 151.544 199.266C121.508 175.429 79.5176 175.423 49.4751 199.247C45.9855 202.014 34.8857 196.351 35.2842 191.916C37.1166 171.522 28.9775 163.383 8.58349 165.215C4.14759 165.614 -1.51504 154.513 1.25241 151.024C25.0761 120.983 25.0695 78.9977 1.23284 48.964C-1.53562 45.4758 4.11791 34.3877 8.55325 34.7871C28.9695 36.6256 37.1176 28.4874 35.2842 8.08354C34.8856 3.64769 45.9855 -2.01499 49.4751 0.752344C79.5176 24.5765 121.508 24.57 151.544 0.732783C155.032 -2.03555 166.119 3.61799 165.719 8.05328C163.879 28.4788 172.025 36.6261 192.446 34.7872C196.881 34.3878 202.535 45.475 199.767 48.9634C175.936 78.9973 175.929 120.984 199.748 151.024C202.515 154.514 196.852 165.614 192.416 165.215C172.017 163.383 163.88 171.531 165.719 191.946Z" fill="${color}"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_9080_67765">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>`;
}

export function Abstract11SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_67735)">
    <mask id="mask0_9080_67735" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="200">
    <path d="M200.5 0H0.5V200H200.5V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_9080_67735)">
    <path d="M72.0579 16.3347C84.8365 -5.4449 116.325 -5.44489 129.103 16.3347L129.567 17.1257C135.463 27.1733 146.209 33.378 157.858 33.4596L158.776 33.466C184.027 33.6428 199.771 60.9123 187.298 82.8687L186.845 83.6661C181.091 93.7953 181.091 106.205 186.845 116.334L187.298 117.131C199.771 139.088 184.027 166.357 158.776 166.534L157.858 166.54C146.209 166.622 135.463 172.827 129.567 182.874L129.103 183.665C116.325 205.445 84.8365 205.445 72.0579 183.665L71.5938 182.874C65.6986 172.827 54.9517 166.622 43.3027 166.54L42.3856 166.534C17.1346 166.357 1.39061 139.088 13.8629 117.131L14.3159 116.334C20.0698 106.205 20.0698 93.7953 14.3159 83.6661L13.8629 82.8687C1.39061 60.9123 17.1346 33.6428 42.3856 33.466L43.3027 33.4596C54.9518 33.378 65.6986 27.1733 71.5938 17.1257L72.0579 16.3347Z" fill="${color}"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_9080_67735">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>`;
}

export function Abstract12SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_67671)">
    <mask id="mask0_9080_67671" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="200">
    <path d="M200.5 0H0.5V200H200.5V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_9080_67671)">
    <path d="M0.5 0H100.5C155.728 0 200.5 44.7715 200.5 100V200H100.5C45.2715 200 0.5 155.228 0.5 100V0Z" fill="${color}"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_9080_67671">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>`;
}

export function Abstract13SVG({ color }) {
    return `<svg width="34" height="34" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9080_67653)">
    <mask id="mask0_9080_67653" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="201" height="200">
    <path d="M200.5 0H0.5V200H200.5V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_9080_67653)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M51.2143 0H1.21429V50C1.21429 75.462 20.2466 96.4788 44.861 99.6002C19.9015 102.402 0.500004 123.578 0.500002 149.286L0.5 199.286H50.5C75.962 199.286 96.9788 180.253 100.1 155.639C102.902 180.599 124.078 200 149.786 200H199.786V150C199.786 124.538 180.753 103.521 156.139 100.4C181.099 97.5984 200.5 76.422 200.5 50.7143V0.714286L150.5 0.714284C125.038 0.714282 104.021 19.7466 100.9 44.361C98.0984 19.4015 76.922 0 51.2143 0Z" fill="${color}"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_9080_67653">
    <rect width="200" height="200" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>
    `;
}

export function PickupSVG({ color }) {
    return `<svg width='27' height='33' viewBox='0 0 27 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <mask id='path-1-inside-1_1867_52106' fill='white'><path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z'/>
        </mask>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z' fill='white'/><path d='M0 0V-2H-2V0H0ZM26.0014 0H28.0014V-2H26.0014V0ZM0 18.9304H-2V20.9304H0V18.9304ZM0.00385723 18.9304L1.48884 17.5907L0.893144 16.9304H0.00385723V18.9304ZM12.6967 32.9996L11.2117 34.3394L12.6622 35.947L14.1499 34.3738L12.6967 32.9996ZM26.0013 18.9304V16.9304H25.14L24.5481 17.5563L26.0013 18.9304ZM26.0014 18.9304V20.9304H28.0014V18.9304H26.0014ZM26.0014 18.9303L24.5481 17.5563L24.0014 18.1346V18.9303H26.0014ZM26.0033 18.9283L27.4567 20.3023L30.6464 16.9283H26.0033V18.9283ZM26.0014 18.9283H24.0014V20.9283H26.0014V18.9283ZM0 2H26.0014V-2H0V2ZM2 18.9304V0H-2V18.9304H2ZM0.00385723 16.9304H0V20.9304H0.00385723V16.9304ZM14.1817 31.6599L1.48884 17.5907L-1.48112 20.2702L11.2117 34.3394L14.1817 31.6599ZM24.5481 17.5563L11.2436 31.6255L14.1499 34.3738L27.4544 20.3046L24.5481 17.5563ZM26.0014 16.9304H26.0013V20.9304H26.0014V16.9304ZM24.0014 18.9303V18.9304H28.0014V18.9303H24.0014ZM24.55 17.5543L24.5481 17.5563L27.4548 20.3043L27.4567 20.3023L24.55 17.5543ZM26.0014 20.9283H26.0033V16.9283H26.0014V20.9283ZM24.0014 0V18.9283H28.0014V0H24.0014Z' fill='${color}' mask='url(#path-1-inside-1_1867_52106)'/>
        <path d='M6 13.4L10 13.4L10 19L16 19L16 13.4L20 13.4L13 6.86667L6 13.4Z' fill='${color}'/>
    </svg>`;
}

function AltPickupSVG1({ color, altColor }) {
    return `<svg width='27' height='33' viewBox='0 0 27 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <defs>
            <pattern id="diagonalHatch" width="5" height="5" patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse">
                <line x1="0" y1="0" x2="0" y2="5" style="stroke:white; stroke-width:5" />
            </pattern>
        </defs>
        <mask id='path-1-inside-1_1867_52106' fill="url(#diagonalHatch)"><path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z'/>
        </mask>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z' fill='white'/><path d='M0 0V-2H-2V0H0ZM26.0014 0H28.0014V-2H26.0014V0ZM0 18.9304H-2V20.9304H0V18.9304ZM0.00385723 18.9304L1.48884 17.5907L0.893144 16.9304H0.00385723V18.9304ZM12.6967 32.9996L11.2117 34.3394L12.6622 35.947L14.1499 34.3738L12.6967 32.9996ZM26.0013 18.9304V16.9304H25.14L24.5481 17.5563L26.0013 18.9304ZM26.0014 18.9304V20.9304H28.0014V18.9304H26.0014ZM26.0014 18.9303L24.5481 17.5563L24.0014 18.1346V18.9303H26.0014ZM26.0033 18.9283L27.4567 20.3023L30.6464 16.9283H26.0033V18.9283ZM26.0014 18.9283H24.0014V20.9283H26.0014V18.9283ZM0 2H26.0014V-2H0V2ZM2 18.9304V0H-2V18.9304H2ZM0.00385723 16.9304H0V20.9304H0.00385723V16.9304ZM14.1817 31.6599L1.48884 17.5907L-1.48112 20.2702L11.2117 34.3394L14.1817 31.6599ZM24.5481 17.5563L11.2436 31.6255L14.1499 34.3738L27.4544 20.3046L24.5481 17.5563ZM26.0014 16.9304H26.0013V20.9304H26.0014V16.9304ZM24.0014 18.9303V18.9304H28.0014V18.9303H24.0014ZM24.55 17.5543L24.5481 17.5563L27.4548 20.3043L27.4567 20.3023L24.55 17.5543ZM26.0014 20.9283H26.0033V16.9283H26.0014V20.9283ZM24.0014 0V18.9283H28.0014V0H24.0014Z' fill='${altColor}' mask='url(#path-1-inside-1_1867_52106)'/>
        <path d='M6 13.4L10 13.4L10 19L16 19L16 13.4L20 13.4L13 6.86667L6 13.4Z' fill='${color}'/>
    </svg>`;
}

function AltPickupSVG2({ color, altColor }) {
    return `<svg width='27' height='33' viewBox='0 0 27 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <defs>
            <pattern id="checkers" x="0" y="0" width="6" height="6" patternUnits="userSpaceOnUse">
                <rect fill="white" x="0" width="3" height="3" y="0"></rect>
                <rect fill="white" x="3" width="3" height="3" y="3"></rect>
            </pattern>
        </defs>
        <mask id='path-1-inside-1_1867_52106' fill="url(#checkers)"><path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z'/>
        </mask>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z' fill='white'/><path d='M0 0V-2H-2V0H0ZM26.0014 0H28.0014V-2H26.0014V0ZM0 18.9304H-2V20.9304H0V18.9304ZM0.00385723 18.9304L1.48884 17.5907L0.893144 16.9304H0.00385723V18.9304ZM12.6967 32.9996L11.2117 34.3394L12.6622 35.947L14.1499 34.3738L12.6967 32.9996ZM26.0013 18.9304V16.9304H25.14L24.5481 17.5563L26.0013 18.9304ZM26.0014 18.9304V20.9304H28.0014V18.9304H26.0014ZM26.0014 18.9303L24.5481 17.5563L24.0014 18.1346V18.9303H26.0014ZM26.0033 18.9283L27.4567 20.3023L30.6464 16.9283H26.0033V18.9283ZM26.0014 18.9283H24.0014V20.9283H26.0014V18.9283ZM0 2H26.0014V-2H0V2ZM2 18.9304V0H-2V18.9304H2ZM0.00385723 16.9304H0V20.9304H0.00385723V16.9304ZM14.1817 31.6599L1.48884 17.5907L-1.48112 20.2702L11.2117 34.3394L14.1817 31.6599ZM24.5481 17.5563L11.2436 31.6255L14.1499 34.3738L27.4544 20.3046L24.5481 17.5563ZM26.0014 16.9304H26.0013V20.9304H26.0014V16.9304ZM24.0014 18.9303V18.9304H28.0014V18.9303H24.0014ZM24.55 17.5543L24.5481 17.5563L27.4548 20.3043L27.4567 20.3023L24.55 17.5543ZM26.0014 20.9283H26.0033V16.9283H26.0014V20.9283ZM24.0014 0V18.9283H28.0014V0H24.0014Z' fill='${altColor}' mask='url(#path-1-inside-1_1867_52106)'/>
        <path d='M6 13.4L10 13.4L10 19L16 19L16 13.4L20 13.4L13 6.86667L6 13.4Z' fill='${color}'/>
    </svg>`;
}

function AltPickupSVG3({ color, altColor }) {
    return `<svg width='27' height='33' viewBox='0 0 27 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <defs>
            <pattern id="dashed" width="14" height="14" x="0" patternTransform="rotate(90 0 0)" patternUnits="userSpaceOnUse">
                <line x1="0" y1="0" x2="0" y2="14" style="stroke:white; stroke-width:18" />
            </pattern>
        </defs>
        <mask id='path-1-inside-1_1867_52106' fill="url(#dashed)"><path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z'/>
        </mask>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M26.0014 0H0V18.9304H0.00385723L12.6967 32.9996L26.0013 18.9304H26.0014V18.9303L26.0033 18.9283H26.0014V0Z' fill='white'/><path d='M0 0V-2H-2V0H0ZM26.0014 0H28.0014V-2H26.0014V0ZM0 18.9304H-2V20.9304H0V18.9304ZM0.00385723 18.9304L1.48884 17.5907L0.893144 16.9304H0.00385723V18.9304ZM12.6967 32.9996L11.2117 34.3394L12.6622 35.947L14.1499 34.3738L12.6967 32.9996ZM26.0013 18.9304V16.9304H25.14L24.5481 17.5563L26.0013 18.9304ZM26.0014 18.9304V20.9304H28.0014V18.9304H26.0014ZM26.0014 18.9303L24.5481 17.5563L24.0014 18.1346V18.9303H26.0014ZM26.0033 18.9283L27.4567 20.3023L30.6464 16.9283H26.0033V18.9283ZM26.0014 18.9283H24.0014V20.9283H26.0014V18.9283ZM0 2H26.0014V-2H0V2ZM2 18.9304V0H-2V18.9304H2ZM0.00385723 16.9304H0V20.9304H0.00385723V16.9304ZM14.1817 31.6599L1.48884 17.5907L-1.48112 20.2702L11.2117 34.3394L14.1817 31.6599ZM24.5481 17.5563L11.2436 31.6255L14.1499 34.3738L27.4544 20.3046L24.5481 17.5563ZM26.0014 16.9304H26.0013V20.9304H26.0014V16.9304ZM24.0014 18.9303V18.9304H28.0014V18.9303H24.0014ZM24.55 17.5543L24.5481 17.5563L27.4548 20.3043L27.4567 20.3023L24.55 17.5543ZM26.0014 20.9283H26.0033V16.9283H26.0014V20.9283ZM24.0014 0V18.9283H28.0014V0H24.0014Z' fill='${altColor}' mask='url(#path-1-inside-1_1867_52106)'/>
        <path d='M6 13.4L10 13.4L10 19L16 19L16 13.4L20 13.4L13 6.86667L6 13.4Z' fill='${color}'/>
    </svg>`;
}

export const PickupSVGs = [PickupSVG, AltPickupSVG1, AltPickupSVG2, AltPickupSVG3];

export const DropoffSVGs = [DefaultSVGSelected, AltDropoffSVG1, AltDropoffSVG2, AltDropoffSVG3];

const CALLBACKS = {
    click: 'onClick',
    contextmenu: 'onContextMenu',
    mouseover: 'onMouseOver',
    mouseout: 'onMouseOut',
};

const POSITIONS = {
    CENTER: [12.5, 33],
    RIGHT: [0, 33],
    LEFT: [25, 33],
    BOTTOM: [12.5, 18],
    TOP: [12.5, 48],
    TOP_LEFT: [25, 48],
    TOP_RIGHT: [0, 48],
    BOT_LEFT: [25, 18],
    BOT_RIGHT: [0, 18],
};

const COLLISION_OFFSETS = [
    POSITIONS.CENTER,
    POSITIONS.LEFT,
    POSITIONS.TOP,
    POSITIONS.RIGHT,
    POSITIONS.BOTTOM,
    POSITIONS.TOP_LEFT,
    POSITIONS.TOP_RIGHT,
    POSITIONS.BOT_LEFT,
    POSITIONS.BOT_RIGHT,
];

export const LABEL_OFFSETS = {
    default: {
        x: 12.5,
        y: 12.5,
    },
    star: {
        x: 20,
        y: 19,
    },
    triangle: {
        x: 20,
        y: 21,
    },
    rectangle: {
        x: 12.5,
        y: 17,
    },
    pentagon: {
        x: 19,
        y: 19,
    },
    cross: {
        x: 19,
        y: 18,
    },
    diamond: {
        x: 15,
        y: 18,
    },
    square: {
        x: 17,
        y: 17,
    },
    circle: {
        x: 17,
        y: 17,
    },
    heart: {
        x: 17,
        y: 18,
    },
};

// Same colored SVG strings recur constantly across paints; cache the base64 data
// urls so repeated btoa calls are avoided.
const svgUrlCache = new Map();

// btoa() throws on any code point above U+00FF. Every SVG here used to be
// generated ASCII, so passing the string straight in was safe — but pin labels
// are free text, and one accented character or emoji would throw and take the
// whole map down. Encode to UTF-8 bytes first. Chunked because
// String.fromCharCode(...bytes) overflows the call stack on long inputs.
const utf8ToBase64 = (str) => {
    const bytes = new TextEncoder().encode(str);
    const CHUNK = 0x8000;
    let binary = '';

    for (let i = 0; i < bytes.length; i += CHUNK) {
        binary += String.fromCharCode.apply(null, bytes.subarray(i, i + CHUNK));
    }

    return btoa(binary);
};

const svgToDataUrl = (svg) => {
    if (!svgUrlCache.has(svg)) {
        svgUrlCache.set(svg, `data:image/svg+xml;base64,${utf8ToBase64(svg)}`);
    }
    return svgUrlCache.get(svg);
};

// Note `tags` / `pinLabels` are absent here: the box is not the pin's concern.
// syncLabelMarker reads them off the same props object for the companion marker.
export function buildMarkerOptions({ key, position, label = ' ', svg, shape, overlapIdx = 0, labelYOffset = 0 }) {
    const [anchorX, anchorY] = COLLISION_OFFSETS[overlapIdx % COLLISION_OFFSETS.length];

    // The pin keeps its own label for the in-pin number, unchanged. The text box
    // rides on a separate marker (see buildLabelMarkerOptions) because a marker
    // carries only one label, and the number cannot be moved into the icon SVG
    // to free the slot: an SVG rendered as an image URL cannot load a web font,
    // so it would silently lose Montserrat.
    return {
        key,
        position,
        label: {
            text: label,
            color: 'white',
            fontFamily: 'Montserrat',
            fontWeight: 'bold',
        },
        icon: {
            labelOrigin: shape
                ? new window.google.maps.Point(
                      LABEL_OFFSETS[shape]?.x || 17,
                      (LABEL_OFFSETS[shape]?.y || 17) + labelYOffset
                  )
                : new window.google.maps.Point(12.5, 12.5 + labelYOffset),
            url: svgToDataUrl(svg),
            anchor: new window.google.maps.Point(anchorX, anchorY),
        },
        zIndex: 1 + overlapIdx,
    };
}

// A 1x1 transparent icon. The box is this marker's *label* — a separate DOM
// element that `.planning-marker-pin-labels` makes pointer-transparent. The icon
// is kept to a single pixel because an icon of any real size is a DOM element
// that intercepts pointer events across its whole rectangle, which is the exact
// problem this companion marker exists to avoid.
const TRANSPARENT_ICON = `<svg width='1' height='1' viewBox='0 0 1 1' fill='none' xmlns='http://www.w3.org/2000/svg'/>`;

// Anchor and labelOrigin deliberately match what the pin marker used to pass for
// the tags box, so the box lands in the same place it always has: centred under
// the pin, pushed clear of a VIP badge by labelYOffset.
export function buildLabelMarkerOptions({ position, text, overlapIdx = 0, labelYOffset = 0 }) {
    const [anchorX, anchorY] = COLLISION_OFFSETS[overlapIdx % COLLISION_OFFSETS.length];

    return {
        position,
        // Belt and braces alongside the CSS: this marker must never take a
        // hover or click away from the pin it describes.
        clickable: false,
        label: {
            text,
            className: 'planning-marker-pin-labels',
        },
        icon: {
            url: svgToDataUrl(TRANSPARENT_ICON),
            labelOrigin: new window.google.maps.Point(12.5, 30 + labelYOffset),
            anchor: new window.google.maps.Point(anchorX, anchorY),
        },
        // Under the pin, so a box never covers the pin it belongs to.
        zIndex: overlapIdx,
    };
}

const LABEL_MARKER = '__pinLabelMarker';

// Creates, updates or removes the companion label marker to match the props.
// Held on the pin marker itself so every existing call site — three
// setMap(null) teardowns and the clusterer — keeps working untouched.
function syncLabelMarker(marker, props, map) {
    const text = pinLabelBoxText(props.tags, props.pinLabels);
    const existing = marker[LABEL_MARKER];

    if (!text) {
        if (existing) {
            existing.setMap(null);
            marker[LABEL_MARKER] = null;
        }
        return;
    }

    const options = buildLabelMarkerOptions({ ...props, text });

    if (existing) {
        existing.setOptions(options);
        return;
    }

    marker[LABEL_MARKER] = new window.google.maps.Marker({
        ...options,
        // On a repaint there is no map argument; inherit whatever the pin is on,
        // including null while it is detached.
        map: map === undefined ? marker.getMap() : map,
    });
}

// Repaints a retained google.maps.Marker in place — position, label, icon and
// stacking follow the same rules as initial construction.
export function applyMarkerProps(marker, props) {
    marker.setOptions(buildMarkerOptions(props));
    syncLabelMarker(marker, props);
}

export const OnwardMarker = function ({ orders, map, callbacks = {}, ...props }) {
    this.ref = new window.google.maps.Marker({
        ...buildMarkerOptions(props),
        map,
    });

    // Mirror the pin's map onto its box. Shadowing the prototype method rather
    // than editing call sites means detaching, re-attaching and clustering all
    // carry the box along for free, with no way for a caller to forget.
    const inheritedSetMap = this.ref.setMap.bind(this.ref);
    this.ref.setMap = function setMapWithLabel(nextMap) {
        inheritedSetMap(nextMap);
        this[LABEL_MARKER]?.setMap(nextMap);
    };

    syncLabelMarker(this.ref, props, map);

    this.listeners = Object.entries(CALLBACKS)
        .filter(([, attr]) => {
            return !!callbacks[attr];
        })
        .map(([event, attr]) => {
            return this.ref.addListener(event, (e) => callbacks[attr](this.ref));
        });

    this.ref.ids = orders;

    return this.ref;
};
